var $bf2b4507594e3d45$exports = {};
$bf2b4507594e3d45$exports = {
  "colorInputLabel": function colorInputLabel(args) {
    return "".concat(args.label, ", ").concat(args.channelLabel);
  },
  "colorNameAndValue": function colorNameAndValue(args) {
    return "".concat(args.name, ": ").concat(args.value);
  },
  "colorPicker": "\u0421\u0440\u0435\u0434\u0441\u0442\u0432\u043E \u0437\u0430 \u0438\u0437\u0431\u0438\u0440\u0430\u043D\u0435 \u043D\u0430 \u0446\u0432\u044F\u0442",
  "colorSwatch": "\u0446\u0432\u0435\u0442\u043D\u0430 \u043C\u043E\u0441\u0442\u0440\u0430",
  "transparent": "\u043F\u0440\u043E\u0437\u0440\u0430\u0447\u0435\u043D",
  "twoDimensionalSlider": "2D \u043F\u043B\u044A\u0437\u0433\u0430\u0447"
};
export { $bf2b4507594e3d45$exports as default };